// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calc-bottom[data-v-7bca9afe]{height:64px;padding:0 28px;display:flex;align-items:center;justify-content:end;gap:6px;color:#777}.calc-bottom span[data-v-7bca9afe]{color:var(--main-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
